import { defineModule } from '@noodl/noodl-sdk';

import Marquee from './nodes/marquee';

defineModule({
	reactNodes: [Marquee]
});
